import { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import avatar5 from "../../assets/img/avatar_5.svg";
import officeIcon from "../../assets/img/icons/black-site-icon.svg";
import deleteIconNormal from "../../assets/img/icons/delete_normal.svg";
import editIconNormal from "../../assets/img/icons/edit-2.svg";
import DotLoader from "../../components/DropdownLoader/DropdownLoader";
import FirstRoundLetterComp from "../../components/FirstRoundLetter/FirstRoundLetter";
import ComponentCircleLoader from "../../components/Loaders/ComponentCircleLoader";
import NoDataComponent from "../../components/NoDataComponent/NoDataComponent";
import SearchWithButton from "../../components/Search/SearchWithButton";
import AssigneeTooltip from "../../components/Tooltip/AssigneeTooltip";
import TaskActionTooltip from "../../components/Tooltip/TaskActionTooltip";
import {
  ColoredButtonWithIcon,
  PrimaryButton,
} from "../../styledComponents/buttons";
import {
  ClientLocationsTableHeaderContainer,
  ClientLocationsTableRowContainer,
} from "../../styledComponents/clients";
import {
  AssignListText,
  ColoredText,
  CommonFlex,
  CommonFlexIcon,
  CommonGrid,
  CommonImage,
  CommonText,
  Container,
  HeaderContainer,
  InputField,
  InputWithLabelSection,
  ShowMoreAssigneeList,
  TableText,
} from "../../styledComponents/common";
import {
  AssigneeRoundImage,
  AssigneeRoundImageSection,
  RoundImageCross,
  RoundPersonImage,
} from "../../styledComponents/createProject";
import { MemberNameDiv } from "../../styledComponents/members";
import { TableItem } from "../../styledComponents/teams";
import { TeamMemberAvatar } from "../../styledComponents/teams";
import {
  DeleteButton,
  EditButton,
  HoveredSection,
  ListHeaderContainer,
  ListItemsContainer,
  NoDataArtwork,
  NoDataContainer,
  OfficesListContainer,
  SingleSiteItem,
} from "../FieldServices/JobSites/jobSitesStyles";
import { IconButtonHolder } from "../Jobs/tasksStyles";
import { CommImageNameComp } from "../Members/CommonComponents";
import DeleteOfficeModal from "./DeleteOfficeModal";
import {
  InfoMapSection,
  InfoSection,
  Tabsection,
  TitleTag,
} from "./officesStyles";

const OfficeList = props => {
  const { t } = useTranslation();
  const [officeDeleteId, setOfficeDeleteId] = useState("");
  const [officeList, setOfficeList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(-1);
  const [moreAssignee, setMoreAssignee] = useState(false);
  const [visibility, setVisibility] = useState(0);
  const moreRef1 = useRef(null);
  const moreRef2 = useRef(null);

  useEffect(() => {
    if (!props.isModalOpen) {
      setOfficeDeleteId("");
    }
  }, [props.isModalOpen]);

  const toggle = id => {
    setOfficeDeleteId(id);
    props.modalToggle();
  };

  const showMoreAssignee = index => {
    setMoreAssignee(true);
    setSelectedRow(index);
  };

  const visibilityChange = state => {
    setVisibility(state);
  };

  //function
  useOutsideClickHandler(moreRef1, moreRef2);
  function useOutsideClickHandler(moreRef1, moreRef2) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          moreRef1.current &&
          !moreRef1.current.contains(event.target) &&
          moreRef2.current &&
          !moreRef2.current.contains(event.target)
        ) {
          setMoreAssignee(false);
          visibilityChange(false);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [moreRef1, moreRef2, moreAssignee]);
  }

  return (
    <Container style={{ paddingBottom: "20px" }}>
      {props.isLoading ? (
        <ComponentCircleLoader />
      ) : (
        <>
          <DeleteOfficeModal
            id={officeDeleteId ? officeDeleteId : ""}
            isOpen={props.isModalOpen}
            toggle={props.modalToggle}
            handleDelete={props.handleDelete}
            isLoading={props.isLoading}
          />

          {props.officeList && props.officeList.length > 0 && (
            <>
              {/* table code */}
              <ClientLocationsTableHeaderContainer columns="200px 300px 200px 200px 140px auto">
                <TableItem>
                  <TableText>{t("team_name")}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{t("team_area")}</TableText>
                </TableItem>
                <TableItem style={{ textAlign: "center" }}>
                  <TableText>{t("location_radius")}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{t("manager")}</TableText>
                </TableItem>
                <TableItem>
                  <TableText>{t("assignees")}</TableText>
                </TableItem>
                {props.selectedOrganization &&
                  (props.selectedOrganization.role === "admin" ||
                    props.selectedOrganization.role === "owner") && (
                    <TableItem>
                      <TableText>{t("actions")}</TableText>
                    </TableItem>
                  )}
              </ClientLocationsTableHeaderContainer>
              {props.officeList.map((office, index) => {
                let managerFound = false;

                return (
                  <>
                    {(props.officeUpdateLoading &&
                      props.updatingOfficeId === office.id) ||
                    (props.officeDeleteLoading &&
                      props.deletingOfficeId === office.id) ? (
                      <DotLoader loading />
                    ) : (
                      <ClientLocationsTableRowContainer
                        // columns={
                        //   props.selectedOrganization &&
                        //   (props.selectedOrganization.role === "admin" ||
                        //     props.selectedOrganization.role === "owner")
                        //     ? 6
                        //     : 5
                        // }
                        columns="200px 300px 200px 200px 140px auto"
                        key={office.id}
                        isLastItem={index === props.officeList.length - 1}
                      >
                        <TableItem
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            props.history.push(
                              `/user/team-details?id=${office.id}`,
                            )
                          }
                        >
                          <CommImageNameComp
                            imgSource={avatar5}
                            name={office.name}
                            size="36px"
                            fontSize="14px"
                            index={index}
                            color={office.color}
                            hoverUnderline
                            showAddDesignation={false}
                          />
                        </TableItem>

                        <TableItem>
                          <CommonText>
                            {office.location &&
                            office.location[0] &&
                            office.location[0].address
                              ? office.location[0].address
                              : "-"}
                          </CommonText>
                        </TableItem>

                        <TableItem style={{ textAlign: "center" }}>
                          <CommonText>
                            {office.location &&
                            office.location[0] &&
                            office.location[0].radius
                              ? office.location[0].radius
                              : "-"}
                          </CommonText>
                        </TableItem>

                        <TableItem
                          style={{ cursor: "pointer" }}
                          // onClick={() =>
                          //   props.history.push(
                          //     `/user/customer-details?id=${client.id}`,
                          //   )
                          // }
                        >
                          {office.employees.map((employee, index) => {
                            if (!managerFound && employee.can_manage) {
                              managerFound = true;

                              return (
                                <div key={employee.id}>
                                  <div
                                    onClick={() =>
                                      props.history.push(
                                        `/user/member-details?id=${employee.user}`,
                                      )
                                    }
                                  >
                                    {employee.avatar ? (
                                      <CommImageNameComp
                                        imgSource={employee.avatar || avatar5}
                                        name={employee.name}
                                        size="36px"
                                        fontSize="13px"
                                        index={index}
                                        color={employee.color}
                                        hoverUnderline
                                      />
                                    ) : (
                                      <CommonFlex gap="14px">
                                        <FirstRoundLetterComp
                                          text={employee.name}
                                          backColor={index}
                                          color={employee.color}
                                        />
                                        <div>
                                          <TableText
                                            hoverUnderline
                                            hoverPointer
                                            name
                                            wrap="normal"
                                          >
                                            {employee.name}
                                          </TableText>
                                          {/* <TableText fontWeight="500">{member.role}</TableText> */}
                                        </div>
                                      </CommonFlex>
                                    )}
                                  </div>
                                </div>
                              );
                            }
                            return null;
                          })}

                          {/* Display message if no manager is found in the office */}
                          {!managerFound && <CommonText>-</CommonText>}
                        </TableItem>

                        <TableItem style={{ cursor: "pointer" }}>
                          <AssigneeRoundImageSection
                            position={office.employees.length}
                            style={{ marginRight: `auto` }}
                          >
                            {office.employees.length > 3 && (
                              <AssigneeRoundImage
                                index="more"
                                onClick={() => {
                                  showMoreAssignee(index);
                                  visibilityChange(true);
                                }}
                                ref={moreRef2}
                                style={{
                                  border: `1px solid #fff`,
                                  paddingLeft: "3px",
                                }}
                              >
                                {`+${office.employees.length - 3}`}
                              </AssigneeRoundImage>
                            )}
                            <>
                              {office.employees.length > 0 ? (
                                <>
                                  {office.employees
                                    .filter((person, index) => index < 3)
                                    .map((filteredPerson, index) => (
                                      <AssigneeRoundImage
                                        key={index}
                                        index={
                                          office.employees.length < 4
                                            ? index + 1
                                            : index + 2
                                        }
                                      >
                                        <AssigneeTooltip
                                          toolTipText={filteredPerson.name}
                                        />
                                        {filteredPerson.avatar ? (
                                          <RoundPersonImage
                                            src={
                                              filteredPerson.avatar
                                                ? filteredPerson.avatar
                                                : avatar5
                                            }
                                            alt=""
                                          />
                                        ) : (
                                          <FirstRoundLetterComp
                                            text={filteredPerson.name}
                                            backColor={index}
                                            color={filteredPerson.color}
                                          />
                                        )}
                                      </AssigneeRoundImage>
                                    ))}
                                  {moreAssignee && selectedRow === index && (
                                    <ShowMoreAssigneeList ref={moreRef1}>
                                      {office.employees.map((member, index) => (
                                        <Fragment key={index}>
                                          <AssigneeRoundImage
                                            index={0}
                                            size="30px"
                                          >
                                            {member.avatar ? (
                                              <RoundPersonImage
                                                src={
                                                  member.avatar
                                                    ? member.avatar
                                                    : avatar5
                                                }
                                                alt=""
                                                size="30px"
                                                borderColor="#c2cce1"
                                              />
                                            ) : (
                                              <FirstRoundLetterComp
                                                text={member.name}
                                                backColor={index}
                                                color={member.color}
                                                size="30px"
                                                fontSize="12px"
                                              />
                                            )}
                                          </AssigneeRoundImage>
                                          <AssignListText>
                                            {member.name}
                                          </AssignListText>
                                        </Fragment>
                                      ))}
                                    </ShowMoreAssigneeList>
                                  )}
                                </>
                              ) : (
                                <CommonText>-</CommonText>
                              )}
                            </>
                          </AssigneeRoundImageSection>
                        </TableItem>
                        {props.selectedOrganization &&
                          (props.selectedOrganization.role === "admin" ||
                            props.selectedOrganization.role === "owner") && (
                            <TableItem>
                              <CommonFlexIcon gap="0px">
                                <IconButtonHolder
                                  onClick={() =>
                                    props.history.push(
                                      `/user/team-details?id=${office.id}`,
                                    )
                                  }
                                >
                                  <CommonImage
                                    src={editIconNormal}
                                    alt="edit"
                                    size="24px"
                                  />
                                  <TaskActionTooltip toolTipText={t("edit")} />
                                </IconButtonHolder>
                                <IconButtonHolder
                                  onClick={() => toggle(office.id)}
                                >
                                  <CommonImage
                                    src={deleteIconNormal}
                                    alt="delete"
                                    size="24px"
                                  />
                                  <TaskActionTooltip
                                    toolTipText={t("delete")}
                                  />
                                </IconButtonHolder>
                              </CommonFlexIcon>
                            </TableItem>
                          )}
                      </ClientLocationsTableRowContainer>
                    )}
                  </>
                );
              })}
            </>
          )}
          {props.officeList && props.officeList.length === 0 && (
            <NoDataComponent title="No Team Records Found." />
          )}
        </>
      )}
    </Container>
  );
};

export default OfficeList;
